import { connect } from 'react-redux';

import { ClippingPlatformState } from '../../../store/clippingPlatformState';
import { baseMapStateToProps } from '../../componentBase';

import { EventsTableStateProps } from './MonitoringTable.types';
import { MonitoringTable } from './MonitoringTable';

function mapStateToProps(state: ClippingPlatformState): EventsTableStateProps {
  return {
    ...baseMapStateToProps(state),
    clients: state.entities.clients.byId,
    users: state.entities.users.byId,
  };
}

export const MonitoringTableContainer = connect(mapStateToProps)(MonitoringTable);
